/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationType,
    ApplicationTypeFromJSON,
    ApplicationTypeFromJSONTyped,
    ApplicationTypeToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesUpdateRequest
 */
export interface BookingTolerancesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesUpdateRequest
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesUpdateRequest
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesUpdateRequest
     */
    relevance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesUpdateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesUpdateRequest
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingTolerancesUpdateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<number>}
     * @memberof BookingTolerancesUpdateRequest
     */
    brands?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BookingTolerancesUpdateRequest
     */
    markets?: Array<string> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof BookingTolerancesUpdateRequest
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingTolerancesUpdateRequest
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof BookingTolerancesUpdateRequest
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {ApplicationType}
     * @memberof BookingTolerancesUpdateRequest
     */
    applicationType?: ApplicationType;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesUpdateRequest
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesUpdateRequest
     */
    toleranceAmountUp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesUpdateRequest
     */
    toleranceAmountDown?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesUpdateRequest
     */
    excludeCarriers?: boolean;
}

export function BookingTolerancesUpdateRequestFromJSON(json: any): BookingTolerancesUpdateRequest {
    return BookingTolerancesUpdateRequestFromJSONTyped(json, false);
}

export function BookingTolerancesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'brands': !exists(json, 'brands') ? undefined : json['brands'],
        'markets': !exists(json, 'markets') ? undefined : json['markets'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'applicationType': !exists(json, 'applicationType') ? undefined : ApplicationTypeFromJSON(json['applicationType']),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'toleranceAmountUp': !exists(json, 'toleranceAmountUp') ? undefined : json['toleranceAmountUp'],
        'toleranceAmountDown': !exists(json, 'toleranceAmountDown') ? undefined : json['toleranceAmountDown'],
        'excludeCarriers': !exists(json, 'excludeCarriers') ? undefined : json['excludeCarriers'],
    };
}

export function BookingTolerancesUpdateRequestToJSON(value?: BookingTolerancesUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
        'description': value.description,
        'relevance': value.relevance,
        'comment': value.comment,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'brands': value.brands,
        'markets': value.markets,
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'applicationType': ApplicationTypeToJSON(value.applicationType),
        'currency': value.currency,
        'toleranceAmountUp': value.toleranceAmountUp,
        'toleranceAmountDown': value.toleranceAmountDown,
        'excludeCarriers': value.excludeCarriers,
    };
}


